// extracted by mini-css-extract-plugin
export default {"statusIndicator":"statusIndicatorw3L5x"};